/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 * @author https://ihateregex.io/
 */
export const CHECK_EMAIL = new RegExp("^[^@ \\t\\r\\n]+@[^@ \\t\\r\\n]+\\.[^@ \\t\\r\\n]+$");
export const CHECK_PASSWORD = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,}$")